import {Button, Placeholder} from "@telegram-apps/telegram-ui";
import {useTranslation} from "react-i18next";
import {useNavigation} from "@/providers/NavigationProvider.tsx";

export const ErrorState = (
  {
    title,
    description
  }: {
    title: string,
    description: string,
  }
) => {
  const { t } = useTranslation();
  const { navigateToRoute } = useNavigation();

  return <Placeholder
    header={title}
    description={description}
    action={<Button mode={"filled"}
                    onClick={()=> navigateToRoute(`/main`, true)}>
      {t("navigation.toMain")}
    </Button>}
  />
}
